///<reference lib="dom"/>

export interface AppMetaInfo {
  base: string;
  release: string;
  sw: boolean;
  assets: Record<string, string>;
}

function metaContent(name: string) {
  return document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content;
}

export function AppMeta(): AppMetaInfo {
  const assets: Record<string, string> = {};
  document.querySelectorAll<HTMLMetaElement>(`meta[name="app-asset"]`).forEach((m) => {
    if (m.dataset.name) assets[m.dataset.name] = m.content;
  });
  const fallbackBase = (globalThis as { __APP_BASE_PATH__?: string }).__APP_BASE_PATH__;
  return {
    base: metaContent("app-base") ?? fallbackBase ?? "/",
    release: metaContent("app-release") ?? "dev",
    sw: metaContent("app-sw") === "on",
    assets,
  };
}

export function AppAssetUrl(meta: AppMetaInfo, name: string): string | undefined {
  const rel = meta.assets[name];
  return rel ? new URL(rel, document.baseURI).href : undefined;
}
